<template>
    <div class = 'buyListBar' >
        <div class = 'backTop-slide top'></div>
        <div class = 'buyListBar-showContent'>
            <!-- 未登录 -->
            <div v-if = '!isLogin' class = 'buyListBar-innerShowC'>
                <p class = 'buyListBar-tip'>
                    <strong class = 'buyListBar-tip--green cur' @click = 'jumpToLogin'>登录</strong>
                    <span>解锁已购课程</span>
                </p>
            </div>

            <!-- 已登录 未购买课程 -->
            <div v-else-if = 'status === 1 || lists.length === 0' class = 'buyListBar-innerShowC'>
                <p class = 'buyListBar-tip'>你还未购买课程哦~</p>
            </div>

            <!-- 已登录 购买过课程 -->
            <div v-else>
                <ul class = 'buyListBar-listContent'>
                    <li v-for = '(list, listIndex) in lists' :key = 'listIndex'>
                        <!-- 已失效课程不能点击 -->
                        <template v-if = 'isCheeseFail(list.status)'>
                             <div class="buyListBar-content loss" >
                                 <div class = 'buyListBar-content-img-loss-wrapper'>
                                     <div class = 'buyListBar-content-img loss'></div>
                                    <!-- <img class = 'buyListBar-content-img loss' src="../assets/images/defaultInvalid.png" :alt="list.title"> -->
                                 </div>


                                <div class="buyListBar-content-item" >
                                    <h6 class = 'buyListBar-content-item--title ell'>已失效课程</h6>
                                </div>
                            </div>
                        </template>

                        <template  v-else>
                            <a :href ="`${list.url}?spm_id_from=${SPM_ID_FROM_PAYED}` |  hostAdapt | csourceTransmit" v-href target="_blank" class="buyListBar-content"  @click = 'jumpOther(list.id)'>
                                <img class = 'buyListBar-content-img' :src="list.cover">

                                <div class="buyListBar-content-item">
                                    <h6 class = 'buyListBar-content-item--title ell'>{{ list.title }}</h6>
                                    <p class = 'buyListBar-content-item--txt ell'>{{ list.update_info }}</p>
                                    <p class = 'buyListBar-content-item--txt green ell'>{{ list.progress | watchInfo }}</p>
                                </div>
                            </a>
                        </template>
                    </li>
                </ul>
            </div>
        </div>
        <div class = 'backTop-slide bottom'></div>
    </div>
</template>
<script>
import { quickLogin, trimHttp } from 'g-public/utils';
import { mapState } from 'vuex';
import http from 'g-public/apis/http'
import { SPM_ID_FROM_PAYED } from '../enum';

export default {

    data() {
        return {
            status: 0,
            lists: [],
            SPM_ID_FROM_PAYED
        };
    },

    computed: {
        ...mapState(['loginInfo']),
        isLogin() {
            if (this.loginInfo && this.loginInfo.isLogin) {
                this.fetchData();
                return true;
            }
            return false;
        }
    },

    mounted() {

    },

    filters: {
        watchInfo (item) {
            if (!item) return '';

            if (item.last_time === -1) return '已看完';
            // if (item.last_time === 0) return '未观看';
            return `上次观看到  ${item.last_ep_index}`;
        }
    },

    methods: {
        fetchData () {
            http({
                url: 'pugv/pay/web/my/paid',
                method: 'get',
                params: {
                    pn: 1,
                    ps: 999
                }
            })
                .then(res => {
                    if (res.status === 200 && res.data.code === 0) {
                        const data = res.data.data.data;
                        if (data) {
                            this.lists = data.map(item => {
                                item.cover = trimHttp(item.cover);
                                return item;
                            });
                        }
                    }
                });

        },

        jumpToLogin() {
            quickLogin();
        },

        jumpOther(seasonid) {
        },

        isCheeseFail (val) {
            // 10 已发布 2 修复待审 3 修复退回 -1 下架
            if (val === 10 || val === 2 || val === 3 || val === -1) return false;
            return true;
        }
    }

};
</script>
<style lang ='less' scoped>
@green: #0BA395;

.buyListBar {
    position: relative;
    font-size: 14px;
    box-shadow: 0 1px 20px 0 rgba(0,0,0,0.10);
    border-radius: 4px;
}

.buyListBar-showContent {
    width: 340px;
    min-height: 100px;
    max-height: 280px;
    /* padding: 10px 0; */
    background: #fff;

    /* border-radius: 2px; */
    overflow-y: auto;
    overscroll-behavior: contain;

    /* &::-webkit-scrollbar {
        width: 6px;;
    }

    &::-webkit-scrollbar-track {
        border-radius: 0;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 0;
        background-color: rgba(95,95,95,.4);
        transition: all .2s;
        border-radius: .5rem;
        width: 2px;

        &:hover {
            background-color: rgba(95,95,95, .7);
        }
    } */
}


.buyListBar-innerShowC {
    line-height: 100px;
    text-align: center;
}

.buyListBar-tip {
    color: #999;
    font-size: 14px;
}

.buyListBar-tip--green {
    color: @green;
}

.cur {
    cursor: pointer;
}

.buyListBar-content {
    display: flex;
    margin-bottom: 12px;
    /* &:last-child {
         margin-bottom: 0px;
    } */

    &.loss {
        cursor: text;
    }
}

.buyListBar-content-img {
    width: 112px;
    height: 63px;
    margin-right: 12px;

    &.loss {
         margin-right: 0px;
         background: url(../assets/images/defaultInvalid.png) center center no-repeat;
         background-size: 88px 88px;
    }
}

.buyListBar-content-item {
    flex: 1;
    line-height: 1.2;
}

.buyListBar-listContent {
    padding: 0px 12px;
    &>li:last-child .buyListBar-content {
         margin-bottom: 0px;
    }
}

.buyListBar-content-item--title {
    font-size: 14px;
    color: #212121;
    width: 186px;
    line-height: 20px;
}

.buyListBar-content-item--txt {
    font-size: 12px;
    line-height: 16px;
    color: #999;
    margin-top: 5px;
    width: 186px;
    word-spacing: 8px;

    &.green {
        color: @green;
    }
}

.buyListBar-content-img-loss-wrapper {
     background: #E7E7E7;
     margin-right: 12px;

}

.backTop-slide {

  /* width: 100%; */
  background: #fff;
  border-radius: 4px 4px 0 0;
  &.top {
       height: 20px;
  }

  &.bottom {
      height: 10px;
        border-radius: 0 0 4px 4px;
  }
}


</style>